module.exports = __webpack_public_path__ + "img/email.cde44a73.svg";